import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { EmailTemplate } from '../../types/entity.types';
import { SaveEmailTemplatesRequest, TestEmailTemplateRequest, ViewEmailTemplatesRequest } from './email-template.types';

import {
  requestSaveEmailTemplates,
  requestTestEmailTemplate,
  requestViewEmailTemplates
} from './email-template.actions';

export const useEmailTemplateApi = () => {
  const dispatch = useDispatch();

  const saveEmailTemplates = useCallback(
    (requestData: SaveEmailTemplatesRequest, onSuccess?: (emailTemplates: EmailTemplate[]) => void) => {
      dispatch(requestSaveEmailTemplates({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const viewEmailTemplates = useCallback(
    (requestData: ViewEmailTemplatesRequest, onSuccess?: (emailTemplates: EmailTemplate[]) => void) => {
      dispatch(requestViewEmailTemplates({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const testEmailTemplate = useCallback(
    (requestData: TestEmailTemplateRequest, onSuccess?: () => void) => {
      dispatch(requestTestEmailTemplate({ requestData, onSuccess }));
    },
    [dispatch]
  );

  return { saveEmailTemplates, viewEmailTemplates, testEmailTemplate };
};
